{
  "enum": {
    "IxmEventsV1TargetStatus": {
      "ACTIVE": "Active",
      "ARCHIVED": "Archived",
      "UNSPECIFIED": "Unspecified"
    }
  },
  "filterEnum": {
    "IxmEventsV1TargetQueryServiceTargetListFilterableFields": {
      "data": {
        "spec": {
          "destination": {
            "!type": "Destination Type"
          }
        }
      },
      "programId": "Program",
      "status": "Status",
      "targetId": "Target"
    }
  },
  "oneOf": {
    "IxmEventsV1Destination": {
      "url": "URL"
    },
    "IxmEventsV1DestinationResponse": {
      "httpResponse": "HTTP Response"
    },
    "IxmEventsV1TargetEventType": {
      "archived": "Archived",
      "created": "Created"
    }
  },
  "sortEnum": {
    "IxmEventsV1TargetQueryServiceTargetListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    }
  }
}